var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import React, { useState, useEffect, useRef } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import NumberFormat from 'react-number-format';
import { zipCodeUpdate, ShowButtons, stateCountyUpdate, countryStateUpdate } from "../store/actions";
import { useSelector, useDispatch } from "react-redux";

import { UserSession } from 'usersession';

var scrollToRef = function scrollToRef(ref) {
    return window.scrollTo(0, ref.current.offsetTop, { behavior: 'smooth' });
};
// General scroll to element function

export default function ZipCode() {
    var _useState = useState(""),
        _useState2 = _slicedToArray(_useState, 2),
        zipCode = _useState2[0],
        setZipCode = _useState2[1];

    var _useState3 = useState(""),
        _useState4 = _slicedToArray(_useState3, 2),
        zipcodeError = _useState4[0],
        setZipCodeError = _useState4[1];

    var dispatch = useDispatch();
    var zipCodeRedux = useSelector(function (state) {
        return state.nameReducer.zipCode;
    });

    var userSession = new UserSession();
    var stateList = JSON.parse(userSession.getStateList());
    var propertyState = "";

    var myRefZip = useRef(null);

    function updateZipCode(propZipCode) {
        setZipCode(propZipCode);

        if (propZipCode.length == 5) {
            axios.get(process.env.REACT_APP_SUNSOFT_RESTSERVER_ZIPCODE + propZipCode, {
                headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
                propertyState = stateList.filter(function (state) {
                    return state.code == response.data.state;
                });
                if (!propertyState || !propertyState.length) {
                    document.getElementById("next-button").disabled = true;
                    dispatch(zipCodeUpdate(""));
                    setZipCodeError('We are not accepting applications for the state of ' + response.data.state);
                } else {
                    userSession.setPropertyZipCode(propZipCode);
                    userSession.setPropertyState(response.data.state);
                    userSession.setPropertyCounty(response.data.counties[0].code);
                    dispatch(zipCodeUpdate(propZipCode));
                    dispatch(stateCountyUpdate(response.data.counties[0].code));
                    dispatch(countryStateUpdate(response.data.state));
                    document.getElementById("next-button").disabled = false;
                }
            }).catch(function (e) {
                setZipCodeError(e.response.data.error);
            });
        }

        if (propZipCode.length < 5) {
            // dont disabled the Next button if zipcode field is empty
            document.getElementById("next-button").disabled = false;
            dispatch(zipCodeUpdate(""));
            userSession.setPropertyZipCode("");
            setZipCodeError("");
        }
    }

    useEffect(function () {
        //This function scroll the slider into view
        !localStorage.getItem('doNotScroll') && scrollToRef(myRefZip);
    }, []);

    useEffect(function () {
        setZipCode(zipCodeRedux);

        // dispatch(ShowButtons(false));

        if (zipCode.length == 5) {
            userSession.setPropertyZipCode(zipCode);
            axios.get(process.env.REACT_APP_SUNSOFT_RESTSERVER_ZIPCODE + zipCode, "", {
                headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
                userSession.setPropertyCounty(response.data.counties[0].code);
                dispatch(stateCountyUpdate(response.data.counties[0].code));
                userSession.setPropertyState(response.data.state);
                dispatch(countryStateUpdate(response.data.state));
            });
        }

        if (!zipCode || zipCode.length < 5) {
            // dont disabled the Next button if zipcode field is empty
            document.getElementById("next-button").disabled = false;
            setZipCodeError("");
        }
    }, []);

    return React.createElement(
        React.Fragment,
        null,
        React.createElement(
            Row,
            { className: 'd-flex justify-content-center pt-1' },
            React.createElement(
                Col,
                { lg: 12 },
                React.createElement(
                    'h2',
                    null,
                    'What is the property zip code? (Skip Next if not Known)'
                )
            ),
            React.createElement(
                Col,
                { md: 10 },
                zipcodeError ? React.createElement(
                    'p',
                    { className: 'text-danger mb-0' },
                    zipcodeError
                ) : null
            ),
            React.createElement(
                Form.Group,
                { as: Col, lg: 4 },
                React.createElement(
                    Form.Label,
                    { className: 'sr-only' },
                    'Zipcode'
                ),
                React.createElement(NumberFormat, { ref: myRefZip, className: 'form-control',
                    placeholder: 'Property Zip Code', format: '#####',
                    value: zipCode, displayType: 'input',
                    thousandSeparator: false, fixedDecimalScale: true,
                    onValueChange: function onValueChange(values) {
                        updateZipCode(values.value);
                    }
                })
            )
        )
    );
}